import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

import type { DeliverabilityList } from 'Types/beAccountDeliverabilityApi'

interface DeliverabilityIndexParams {
  list: number
}

const endpoints = ((baseURL: string) => {
  return {
    getDeliverabilityIndex: (params: DeliverabilityIndexParams) =>
      `${baseURL}/api/deliverability?${encodeParams(params) as string}`,
  }
})(process.env.BEACCOUNTDELIVERABILITY_URL as string)

export const beAccountDeliverabilityApiGetDeliverabilityIndex = async (
  params: DeliverabilityIndexParams,
): Promise<DeliverabilityList | null> => {
  const url = endpoints.getDeliverabilityIndex(params)

  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}
/**
 * @param {Object} params
 */
